import styled from "styled-components";

export const ThreadsInfo = styled.p`
    font-size: 14px;
  position: relative;
  top: 0.3rem;
`;